export default __webpack_public_path__ + "static/media/Newsletter 010.30de9459.png";